import { useQuery } from '@tanstack/react-query';
import { CACHE_TIME } from '@hygge/shared';
import { getLatestLinkedinParserRelease } from '@/lib/linkedin-parser';

export const linkedinParserKeys = {
  all: ['linkedin-parser'] as const,
  latestRelease: () => [...linkedinParserKeys.all, 'latest-release'] as const,
};

export function useLatestLinkedinParserRelease() {
  return useQuery({
    queryKey: linkedinParserKeys.latestRelease(),
    queryFn: getLatestLinkedinParserRelease,
    staleTime: CACHE_TIME.DEFAULT,
  });
}
